import React from 'react'

function Counter({ count }) {
  return (
    <h1 className='p-1 flex flex-col justify-center items-center text-xl mt-2'>Your Score : {count}</h1>
  )
}

export default Counter